export class IdentityApply {
    constructor(
        public id: string,
        public applicantName: string,
        public created_at: Date,
        public create_from: string,
        public identity_document_url: string
    ) { }
}
